module.exports = __webpack_public_path__ + "static/media/turns_100.af6ed9d1.png";